import type { LimitType } from '../../types/files';
import type { WidgetMessages } from '../../types/widgetMessages';

import { FILE_MB_LIMIT, FILES_COUNT_LIMIT } from '../../constants/files';

/**
 * Сообщение при превышении лимита количества или размера вложений.
 */
export function getFileUploadErrorMessages(limitType: LimitType, errorMessages: WidgetMessages['errors']): string {
  switch (limitType) {
    case 'count':
      return errorMessages.fileUploadCount(FILES_COUNT_LIMIT);
    case 'size':
      return errorMessages.fileUploadSize(FILE_MB_LIMIT);
    case 'all':
      return errorMessages.fileUploadAll(FILES_COUNT_LIMIT, FILE_MB_LIMIT);
    default:
      return errorMessages.fileUploadAll(FILES_COUNT_LIMIT, FILE_MB_LIMIT);
  }
}
